/*
options: {decimals:2,decimal:',',thousands:'.',pre:'R$ ',pos:''} (optional)
use: v-model="valor" v-money="{decimals:2,decimal:',',thousand:'.',pre:'R$ ',pos:''}"
*/

const money = (string = '', options = {}) => {
  let decimals = options && options.decimals && options.decimals >= 0 ? parseInt(options.decimals) : 2;
  let decimal = options && typeof options.decimal == 'string' ? options.decimal : ',';
  let thousand = options && typeof options.thousand == 'string' ? options.thousand : '.';
  let pre = options && typeof options.pre == 'string' ? options.pre : 'R$ ';
  let pos = options && typeof options.pos == 'string' ? options.pos : '';

  let mask = '';

  string = ('' + string).replace(/[^0-9]/g, "") || "0";
  let number = parseInt(string) || 0;

  const digits = number.toString().split("").reverse();

  for (let d = digits.length; d < (decimals + 1); d++) {
    digits.push(0);
  }

  digits.map((d, i) => {
    if (i == decimals) {
      mask = decimal + mask;
    }
    if (i > (decimals + 1) && ((i - 2) % (decimals + 1)) == 0) {
      mask = thousand + mask;
    }
    mask = d + mask;
  });

  return pre + mask + pos;
}

export default money;
